// olap-client/src/components/chat/ChatWindow.jsx
import React, { useContext, useRef, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Context } from '../..';
import MessageItem from '../MessageItem';
import ChatHeader from './ChatHeader';
import MessageInput from './MessageInput';
import DateSeparator from './DateSeparator';
import { isSameDay, getMessageGroupTitle } from '../../utils/dateUtils';

const ChatWindow = observer(() => {
  const { chat } = useContext(Context);
  const messagesEndRef = useRef(null);

  // Автопрокрутка вниз при новых сообщениях
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [chat.messages]);

  if (!chat.activeChat) {
    return (
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f4f4f5',
        color: '#707579',
        fontSize: '16px'
      }}>
        Выберите чат для начала общения
      </div>
    );
  }

  // Группируем сообщения по дате
  const groupedMessages = [];
  let currentDate = null;

  chat.messages.forEach((msg, idx) => {
    if (!msg) return;
    
    // Проверяем, нужно ли добавить разделитель даты
    if (!currentDate || !isSameDay(currentDate, msg.createdAt)) {
      currentDate = msg.createdAt;
      groupedMessages.push({
        type: 'date',
        id: `date-${msg.createdAt}`,
        title: getMessageGroupTitle(msg.createdAt),
        date: msg.createdAt
      });
    }
    
    groupedMessages.push({
      type: 'message',
      ...msg,
      idx
    });
  });

  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      background: '#ffffff',
      minWidth: 0,
      overflow: 'hidden'
    }}>
      <ChatHeader />

      {/* Сообщения */}
      <div 
        style={{ 
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '15px',
          background: '#e6ebee',  // Фон как в Telegram
          minHeight: 0
        }}
      >
        {groupedMessages.length === 0 ? (
          <div style={{ textAlign: 'center', color: '#999', marginTop: '50px' }}>
            Начните диалог!
          </div>
        ) : (
          groupedMessages.map((item, idx) => {
            if (item.type === 'date') {
              return <DateSeparator key={item.id} title={item.title} />;
            }
            
            const isMine = item.senderId && String(item.senderId) === String(chat.currentUserId);
            
            return (
              <MessageItem
                key={item.id || idx}
                msgId={item.id}
                idx={item.idx}
                isMine={isMine}
              />
            );
          })
        )}
        <div ref={messagesEndRef} />
      </div>

      <MessageInput />
    </div>
  );
});

export default ChatWindow;